import React from 'react';
import { Outlet } from 'react-router-dom';
import ZpHeadNavbar from './ZpHeadNavbar';
import ZpHeadFooter from './ZpHeadFooter';

const ZpHeadLayout = () => {
    return (
        <div className="flex flex-col h-screen overflow-hidden bg-gray-50 font-sans">
            <ZpHeadNavbar />
            <div className="flex-grow flex flex-col overflow-y-auto overflow-x-hidden">
                <main className="flex-grow p-8">
                    <Outlet />
                </main>
                <ZpHeadFooter />
            </div>
        </div>
    );
};

export default ZpHeadLayout;
